import angular from 'angular';
import DataBroker from 'cars-ng-data-broker';
import Constants from './constants';
import featureFlagService from './featureFlag.service';

export default angular.module('cars.vdp.config', [
    DataBroker
])
.constant('vdpConstants', Constants)
.service('featureFlagService', featureFlagService)

.name;
